import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { API_URL } from './api'

// Global fetch interceptor: redirect to /login on any 401 from the API
const originalFetch = window.fetch
window.fetch = function (...args) {
  return originalFetch.apply(this, args).then(res => {
    // Only intercept 401 from our API (not external URLs)
    const url = typeof args[0] === 'string' ? args[0] : (args[0] as Request | undefined)?.url
    if (res.status === 401 && url && url.startsWith(API_URL)) {
      localStorage.removeItem('atlas_token')
      localStorage.removeItem('atlas_user')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return res
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
